import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15.333 10.8 2.667 3m0 0-2.667 3m2.667-3H7.2m0-7.2h10m4.4-.6v12a3.6 3.6 0 0 1-3.6 3.6H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12A3.6 3.6 0 0 1 21.6 6"
    />
  </svg>
);
export default SvgCalendar01;
